import { useNavigate } from "react-router-dom";

import { getPostLoginRedirectPath } from "helpers/authSession";
import { useAuthentication } from "store/backend/login";
import { useSnackbarContext } from "widgets/SnackBar/SnackBar";

import { LOGIN_COPY, LOGIN_FIELD_NAMES } from "./constants/loginContent";

const useLoginSubmit = ({ setApiError, getIsdCodeForCountry }) => {
  const navigate = useNavigate();
  const { openSnackbar } = useSnackbarContext();
  const { mutate: login, isPending } = useAuthentication();

  const handleSubmit = (values, { setSubmitting }) => {
    setApiError("");

    const isdCode = getIsdCodeForCountry?.(
      values[LOGIN_FIELD_NAMES.COUNTRY_CODE]
    );

    login(
      {
        mobile: values[LOGIN_FIELD_NAMES.MOBILE],
        password: values[LOGIN_FIELD_NAMES.PASSWORD],
        isdCode,
      },
      {
        onSuccess: () => {
          openSnackbar(LOGIN_COPY.SUCCESS_MESSAGE);
          navigate(getPostLoginRedirectPath(window.location.search), {
            replace: true,
          });
        },
        onError: (response) => {
          setApiError(response?.message || LOGIN_COPY.DEFAULT_ERROR_MESSAGE);
        },
        onSettled: () => {
          setSubmitting(false);
        },
      }
    );
  };

  return { handleSubmit, isPending };
};

export default useLoginSubmit;
